import { SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { BlogArticle } from 'src/app/blog-article.model';
import { BlogService } from 'src/app/blog.service';
import { MetaSetterService } from 'src/app/general/meta-setter.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-article-list',
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.scss']
})
export class ArticleListComponent implements OnChanges {

  @Input() author: string;
  @Input() category: string;
  @Input() query: string;
  @Input() blogLoading: boolean;
  @Output() blogLoadingChange = new EventEmitter<boolean>();
  @Input() authorMode: boolean = false;
  @Input() authorName: string = "";
  @Input() currentPage: number;
  @Input() nextPageURL: string;

  blogArticles: Array<BlogArticle> = [];
  blogError = false;
  blogInputPage = 1;
  totalPostCount = 0;
  blogPageSize = 15;

  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;

  environment = environment;

  constructor(
    private blogService: BlogService,
    private router: Router,
    private route: ActivatedRoute,
    private metaSetter: MetaSetterService,
  ) {
    this.blogInputPage = this.currentPage + 1;
  }

  getArticles() {
    this.blogLoading = true;
    // this.blogLoadingChange.emit(this.blogLoading);
    this.blogError = false;
    this.totalPostCount = 0;

    this.blogService.getArticleSummariesPage(this.author, this.category, this.query, this.currentPage * this.blogPageSize, this.blogPageSize)
      .subscribe(({articles, totalCount}) => this.postArticlesFetch(articles, totalCount), () => {
        this.blogError = true;
    });
  }

  postArticlesFetch(articles: Array<BlogArticle>, totalCount: number) {
    this.totalPostCount = totalCount;

    if (articles && articles.length > 0) {
        articles = articles.filter(post => post.tags && post.tags.length > 0);
    }
    
    // if this page is not the last one in this set, apply a tag to the document head to say where the next link is (if provided by parent component)
    if (this.currentPage < this.numberOfPages() - 1) {
      this.metaSetter.setNextURL(this.nextPageURL);
    }

    this.blogArticles = articles;
    
    this.blogLoading = false;
    this.blogLoadingChange.emit(this.blogLoading);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // ignore change if only affected attribute is the self-changing blogLoading
    if (Object.keys(changes).some(c => !["blogLoading"].includes(c))) {
      this.blogPageSize = this.authorMode ? 10 : 15;
      this.blogInputPage = this.currentPage + 1;
      this.getArticles();
    }
  }

  setBlogPage(pageNo: number): void {
    if (this.isValidPageNumber(pageNo)) {
      this.currentPage = pageNo - 1;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {page: this.currentPage + 1},
        queryParamsHandling: "merge",
        replaceUrl: true,
      });
      this.blogInputPage = pageNo;
      this.getArticles();
    }
  }

  numberOfPages(): number {
    return Math.ceil(this.totalPostCount / this.blogPageSize)
  }

  isValidPageNumber(number: number): boolean {
    return number != this.currentPage + 1 
        && number > 0 && number <= this.numberOfPages();
  }

}
